import apiClient from '../apiClient';
import { GET_TEMPLATE_RESTAURANT_PROFILE_DATA_URL } from '../apiUrl';

const getTemplateRestaurantProfileApi = () => {
  return apiClient.get(GET_TEMPLATE_RESTAURANT_PROFILE_DATA_URL);
};

export default getTemplateRestaurantProfileApi;
